module.exports = __webpack_public_path__ + "img/motion-bg.f55dfa8d.png";